import * as React from "react";
import { NotFound } from "./ErrorPages";
import { parseQuerystring } from "./utility";
import { JSX } from "react";

interface QueryStringRestrictedProps {
  children: React.ReactNode;
  // Note that if you have a hashValue, it has to come AFTER the query parameters
  // Otherwise the query parameters are considered part of the hash value (window.location.hash)
  hashValue?: string;
  queryStringKey: string;
  queryStringValue: string;
}

const QueryStringRestricted = (props: QueryStringRestrictedProps): JSX.Element => {
  const query = parseQuerystring(window.location.search);
  const hashValue = window.location.hash.substring(1); // cut the # out of the hash value

  if (Object.keys(query).length > 0 && (window.location.host.includes("sit") || window.location.host.includes("dev") || window.location.host.includes("localhost")) && query[props.queryStringKey] === props.queryStringValue && (!props.hashValue || props.hashValue === hashValue)) {
    return <>{props.children}</>;
  }

  return <NotFound />;
};

export default QueryStringRestricted;
